import { useAppSelector } from './useAppSelector'

export const useCountries = () => useAppSelector((state) => state.countries)
